(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["notch-cart"]) return;
  try {
    
  // Disable on a timeout, never synchronously inside the handler: disabling a
  // submit button drops its name from the payload, and this form tells
  // "update" from "checkout" by name alone.
  const notchGuardCartForm = (form) => {
    if (form.dataset.notchGuarded) return;
    form.dataset.notchGuarded = 'true';
    let submitted = false;
    form.addEventListener('submit', (event) => {
      if (submitted) { event.preventDefault(); return; }
      submitted = true;
      setTimeout(() => {
        form.querySelectorAll('button[type="submit"]').forEach((button) => { button.disabled = true; });
      }, 0);
    });
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      submitted = false;
      form.querySelectorAll('button[type="submit"]').forEach((button) => { button.disabled = false; });
    });
  };

  const notchGuardAllCartForms = (scope) => {
    (scope || document).querySelectorAll('[data-notch-cart-form]').forEach(notchGuardCartForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => notchGuardAllCartForms());
  } else {
    notchGuardAllCartForms();
  }

  document.addEventListener('shopify:section:load', (event) => notchGuardAllCartForms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notch-header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-notch-header]');
    if (!header) return;

    // ---- directional header: hidden on the way down, back on the way up ----
    const THRESHOLD = 8;
    let last = window.scrollY;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;
      const delta = y - last;
      if (Math.abs(delta) > THRESHOLD) {
        // Never hide over the first screenful, and never out from under a
        // keyboard user who has just tabbed into it.
        const hide = delta > 0 && y > header.offsetHeight && !header.contains(document.activeElement);
        header.toggleAttribute('data-notch-header-hidden', hide);
        last = y;
      }
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    header.addEventListener('focusin', () => header.removeAttribute('data-notch-header-hidden'));

    // ---- the drawer ----
    const drawer = document.querySelector('[data-notch-nav]');
    const opener = header.querySelector('[data-notch-nav-open]');

    if (drawer && opener) {
      const setExpanded = () => opener.setAttribute('aria-expanded', String(drawer.open));

      opener.addEventListener('click', () => {
        drawer.showModal();
        setExpanded();
      });

      drawer.addEventListener('click', (event) => {
        // A click on the dialog element itself is a click on the backdrop:
        // the panel fills the box, so anything else has a closer target.
        if (event.target === drawer || event.target.closest('[data-notch-nav-close]')) drawer.close();
        if (event.target.closest('a')) drawer.close();
      });

      drawer.addEventListener('close', setExpanded);
    }

    // ---- current item ----
    // request.path marks a real page. Everything on the homepage is a hash,
    // so the band crossing the middle of the viewport is what "current" means
    // there — without this the nav's underline never appears on Home.
    const links = Array.from(header.querySelectorAll('[data-notch-nav-link]'));
    const bands = new Map();

    for (const link of links) {
      const hash = (link.getAttribute('href') || '').split('#')[1];
      const band = hash && document.getElementById(hash);
      if (band) bands.set(band, link);
    }

    if (bands.size && 'IntersectionObserver' in window) {
      const seen = new Set();
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) seen.add(entry.target);
            else seen.delete(entry.target);
          }
          for (const [band, link] of bands) {
            link.toggleAttribute('data-notch-nav-current', seen.has(band));
          }
        },
        { rootMargin: '-50% 0px -50% 0px' }
      );

      for (const band of bands.keys()) observer.observe(band);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notch-hero"] && !Shopify.designMode) return;
  try {
    
  // The hero clock. Two things are on a timer — the clip loops on a trimmed
  // cut, and the flavour advances — and they run off ONE interval so they
  // stay locked to each other.
  //
  // The flavour changes on the snap beat, the frame where the streamers go
  // taut. That is the conceit: the colour turns on the snap, not on a timer
  // that happens to be running alongside it.
  (() => {
    // Shopify bundles section JS and can run it before the section's own
    // markup is parsed — on one load the band was simply absent and the clip
    // played at rate 1 with no cycle at all. Wait for the DOM rather than
    // hoping for the order.
    const start = () => {
      const band = document.querySelector('[data-hero-band]');
      if (!band) return;

    const configEl = document.querySelector('[data-hero-config]');
    const defaults = {
      cut: 6.35,
      rate: 1,
      snapAt: 3.55,
      syncHold: 0.05,
      cycle: true,
      flavours: ['mango', 'ice-mint', 'peach', 'blackcurrant'],
    };

    let HERO = defaults;
    try {
      HERO = Object.assign({}, defaults, JSON.parse(configEl.textContent));
    } catch (error) {
      // A malformed blob must not take the band down with it.
    }

    const loops = Array.from(band.querySelectorAll('video[data-hero-loop]'));
    const packs = Array.from(band.querySelectorAll('[data-hero-pack]'));
    const tint = band.querySelector('[data-hero-tint]');
    const still = matchMedia('(prefers-reduced-motion: reduce)');

    let index = 0;
    let visible = true;
    let holdFrom = null;

    const apply = () => {
      // The attribute picks a declared token; see the note in the stylesheet.
      band.dataset.heroFlavour = HERO.flavours[index];
      packs.forEach((pack, n) => pack.toggleAttribute('data-hero-current', n === index));
    };

    apply();

    // Autoplay rejects under low-power mode; the poster carries the band when
    // it does, so the rejection is swallowed rather than handled.
    const play = (video) => video.play().catch(() => {});

    loops.forEach((video) => {
      video.muted = true;
      video.volume = 0;
      play(video);

      // Nothing pauses this clip. The first play() is REFUSED — swallowed
      // by design above — and on a phone it stayed refused, so the band sat
      // on a still frame. Verified by trapping pause(): it is never called,
      // and an explicit play() runs fine.
      //
      // Asking again when frames arrive covers a refusal that was really a
      // cold buffer, which is likely here: the mobile rendition is the
      // heaviest file this theme serves.
      //
      // readyState is checked BEFORE listening, and the listeners are not
      // `once`. With preload="auto" and a warm cache both events can fire
      // before this line runs, and a `once` listener for an event already
      // past never fires — so the buffer retry was dead in exactly the
      // common case, leaving the gesture as the only thing that recovered
      // it. Which is the symptom: nothing on landing, playing after a
      // scroll.
      const retry = () => { if (visible && video.paused) play(video); };
      if (video.readyState >= 2) retry();
      ['loadeddata', 'canplay', 'canplaythrough'].forEach((evt) =>
        video.addEventListener(evt, retry)
      );

      // A short backstop for a refusal that is neither buffer nor gesture.
      // Three asks, then it stops: past that it is a policy no amount of
      // asking changes — Low Power Mode refuses every time until a real
      // gesture — and the poster is the designed answer for that.
      let asks = 0;
      const nudge = setInterval(() => {
        if (++asks > 3 || !video.paused) { clearInterval(nudge); return; }
        retry();
      }, 400);
    });

    // The gesture retry. Passive and once: it costs one listener and is gone
    // the moment anybody touches the page.
    ['pointerdown', 'touchstart', 'scroll'].forEach((evt) =>
      document.addEventListener(
        evt,
        () => loops.forEach((video) => { if (video.paused && visible) play(video); }),
        { once: true, passive: true }
      )
    );

    if (still.matches) {
      // Hold the frame the snap lands on rather than degrading to nothing,
      // and stop the cycle with it: the movement is the thing being opted out
      // of, and the colour change is movement.
      loops.forEach((video) => {
        video.pause();
        video.currentTime = HERO.snapAt;
      });
      return;
    }

    // Below the fold the clip is decoding for nobody. Pausing there is worth
    // real battery on a phone.
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            visible = entry.isIntersecting;
            loops.forEach((video) => (visible ? play(video) : video.pause()));
          }
        },
        { rootMargin: '0px' }
      );
      observer.observe(band);
    }

    const restart = (video) => {
      video.currentTime = 0;
      video.dataset.prevT = '0';
      play(video);
    };

    setInterval(() => {
      const now = performance.now();

      if (!visible) return;

      let snapped = false;

      loops.forEach((video) => {
        // Some browsers reset the rate silently on seek. Setting it every
        // tick stutters, so the guard is load-bearing.
        if (video.playbackRate !== HERO.rate) video.playbackRate = HERO.rate;

        const t = video.currentTime;
        const prev = video.dataset.prevT ? Number(video.dataset.prevT) : t;

        // The snap is the playhead CROSSING snapAt, not being near it: a 16ms
        // tick advances more video than a proximity test can catch.
        if (prev < HERO.snapAt && t >= HERO.snapAt) snapped = true;
        video.dataset.prevT = String(t);

        // A frame early. Waiting for `ended` shows a black frame on Safari.
        if (t >= HERO.cut - 0.03 || video.ended) restart(video);
      });

      if (!HERO.cycle) return;

      // The colour turns on the snap, not on a timer running alongside it.
      // That is the whole conceit, and it is why there is no second clock
      // here: the playhead is the only thing that decides when this happens.
      if (snapped) holdFrom = now;
      if (holdFrom !== null && now - holdFrom >= HERO.syncHold * 1000) {
        holdFrom = null;
        index = (index + 1) % HERO.flavours.length;
        apply();
      }
      }, 16);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notch-outcome-tabs"] && !Shopify.designMode) return;
  try {
    
  const notchInitTabs = (root) => {
    if (root.dataset.notchReady) return;
    const list = root.querySelector('[data-notch-tablist]');
    const panels = Array.from(root.querySelectorAll('[data-notch-panel]'));
    if (!list || panels.length < 2) return;
    root.dataset.notchReady = 'true';

    const tabs = panels.map((panel, index) => {
      const panelId = `${root.id}-panel-${index}`;
      const tab = document.createElement('button');
      panel.id = panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '0');
      tab.type = 'button';
      tab.id = `${panelId}-tab`;
      tab.className = 'notch-tabs__tab';
      tab.textContent = panel.dataset.notchTab || String(index + 1);
      tab.dataset.notchTab = panel.dataset.notchTab || '';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      panel.setAttribute('aria-labelledby', tab.id);
      list.append(tab);
      return tab;
    });

    const select = (chosen) => {
      tabs.forEach((tab, index) => {
        const on = index === chosen;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        panels[index].hidden = !on;
      });
    };

    list.addEventListener('click', (event) => {
      const index = tabs.indexOf(event.target.closest('[role="tab"]'));
      if (index > -1) select(index);
    });

    list.addEventListener('keydown', (event) => {
      const from = tabs.indexOf(document.activeElement);
      if (from < 0) return;
      let to = from;
      if (event.key === 'ArrowRight') to = (from + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') to = (from - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') to = 0;
      else if (event.key === 'End') to = tabs.length - 1;
      else return;
      event.preventDefault();
      select(to);
      tabs[to].focus();
    });

    root.notchSelectPanel = (panel) => {
      const index = panels.indexOf(panel);
      if (index > -1) select(index);
    };

    select(0);
  };

  const notchInitAllTabs = (scope) => {
    (scope || document).querySelectorAll('[data-notch-tabs]').forEach(notchInitTabs);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => notchInitAllTabs());
  } else {
    notchInitAllTabs();
  }

  document.addEventListener('shopify:section:load', (event) => notchInitAllTabs(event.target));

  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-notch-panel]');
    const root = panel && panel.closest('[data-notch-tabs]');
    if (root && root.notchSelectPanel) root.notchSelectPanel(panel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notch-prelaunch"]) return;
  try {
    
  // A short burst of house-coloured confetti when the confirmation renders.
  // DOM spans, no canvas, no library; skipped entirely for reduced motion.
  window.notchCelebrate = () => {
    notchGateDone();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const host = document.querySelector('.notch-prelaunch__panel') || document.body;
    const colours = ['var(--notch-accent)', 'var(--color-foreground)', 'var(--color-foreground-muted)'];
    for (let i = 0; i < 90; i++) {
      const bit = document.createElement('span');
      const size = 5 + Math.random() * 7;
      bit.style.cssText = `position:fixed;left:${Math.random() * 100}vw;top:-3vh;width:${size}px;height:${size * (0.4 + Math.random())}px;background:${colours[i % colours.length]};z-index:400;pointer-events:none;border-radius:1px;`;
      const fall = bit.animate(
        [
          { transform: 'translateY(0) rotate(0turn)', opacity: 1 },
          { transform: `translateY(${60 + Math.random() * 45}vh) rotate(${(Math.random() * 2 - 1).toFixed(2)}turn)`, opacity: 0 },
        ],
        { duration: 1600 + Math.random() * 1600, delay: Math.random() * 350, easing: 'cubic-bezier(.15,.45,.45,1)', fill: 'forwards' }
      );
      fall.onfinish = () => bit.remove();
      host.append(bit);
    }
  };
  // Remembering that this browser already gave an address, so exit intent
  // never lands on someone who is already on the list. Set here rather than
  // at the two success sites because both of them end up calling this.
  const notchGateDone = () => {
    try { localStorage.setItem('notch_gate_done', '1'); } catch (e) { /* private mode */ }
  };

  const notchMaybeCelebrate = () => {
    const marker = document.querySelector('.notch-prelaunch [data-notch-captured]');
    if (marker) window.notchCelebrate();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', notchMaybeCelebrate);
  else notchMaybeCelebrate();

  // ── opening the gate from a script ───────────────────────────────────
  //
  // Two signals can open the panel without a click — exit intent and an ad
  // arrival — and they share one opener, so the rules cannot drift between
  // them: once per tab on notch_gate_shown, never once an address is in,
  // never over another fragment (the nutrition overlay, a gallery slide),
  // never in the editor. Opening is a hash change, the same move the
  // checkout links make, so :target is the only thing that decides the
  // panel is open and the browser Back button still closes it.
  //
  // The trigger is written onto the panel so the copy variant and the
  // gate_opened event can read it, and it is cleared the moment the panel
  // is no longer the target — by Back, by the X, by the scrim, by anything
  // — so a later checkout click never inherits an earlier trigger's copy.
  const notchGateRead = (area, key) => { try { return window[area].getItem(key); } catch (e) { return null; } };
  const notchGateBlocked = (panel) => notchGateRead('localStorage', 'notch_gate_done')
    || notchGateRead('sessionStorage', 'notch_gate_shown')
    || panel.classList.contains('notch-prelaunch--open')
    || panel.querySelector('[data-notch-captured], .notch-prelaunch__success-heading')
    || !!location.hash;
  const notchOpenGate = (panel, trigger) => {
    if (notchGateBlocked(panel)) return false;
    try { sessionStorage.setItem('notch_gate_shown', '1'); } catch (e) { /* private mode */ }
    panel.dataset.notchOpenedBy = trigger;
    location.hash = panel.id;
    // Focus only with a real keyboard: on a phone the soft keyboard would
    // rise over the copy before it has been read.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const field = panel.querySelector('.notch-field__input');
      if (field) field.focus({ preventScroll: true });
    }
    return true;
  };
  const notchGateReset = () => {
    const panel = document.querySelector('.notch-prelaunch');
    if (!panel) return;
    window.addEventListener('hashchange', () => {
      if (location.hash !== '#' + panel.id) delete panel.dataset.notchOpenedBy;
    });
  };
  notchGateReset();

  // ── already on the list ──────────────────────────────────────────────
  //
  // The address was given in this browser (notch_gate_done, set at both
  // success sites). Exit intent and the ad open already refuse to fire on
  // it; the Checkout tap still has to explain the refusal, and must not ask
  // for the address again. One attribute, read by the stylesheet.
  const notchGateListed = () => {
    const panel = document.querySelector('.notch-prelaunch');
    if (!panel) return;
    if (notchGateRead('localStorage', 'notch_gate_done') === '1') panel.dataset.notchCopy = 'done';
  };
  notchGateListed();

  // ── exit intent ────────────────────────────────────────────────────────
  //
  // The gate already opens from every checkout control. This opens it from
  // the other exit — the pointer leaving the page for the tab bar — which is
  // the last moment a leaving shopper is still reachable.
  //
  // Deliberately narrow, because a popup that fires when it should not is
  // worse than one that never fires:
  //   · fine pointers only. A phone has no exit to detect, and a touch near
  //     the top edge is a shopper scrolling, not leaving.
  //   · armed after a delay, so it cannot land on someone who just arrived.
  //   · once per tab, and never again on any tab once an address is in.
  //   · never in the theme editor, where it would fire on every save.
  //   · never while the panel is already open.
  const notchExitIntent = () => {
    const panel = document.querySelector('.notch-prelaunch');
    if (!panel || panel.dataset.notchExit !== 'on') return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (notchGateBlocked(panel)) return;

    // Armed late so it cannot land on someone who has just arrived, and every
    // guard is re-checked at the moment of firing rather than at setup.
    const armedAt = Date.now() + 6000;
    const open = () => { if (Date.now() >= armedAt) notchOpenGate(panel, 'exit'); };

    // Desktop: the pointer crossing the top edge with nothing to land on is
    // the browser chrome, which is the last moment a leaving shopper is still
    // reachable.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', (event) => {
        if (event.relatedTarget || event.clientY > 0) return;
        open();
      });
      return;
    }

    // Phones have no exit to detect, so the signal is the reverse flick: a
    // shopper who has read past the middle of the page and then throws it
    // back up is heading for the address bar or the back gesture. Depth
    // first, so it cannot fire on someone still on the hero, and the upward
    // travel has to accumulate without a single downward correction, so an
    // ordinary re-read of the band above never trips it.
    let deep = false;
    let lastY = window.scrollY;
    let up = 0;
    document.addEventListener('scroll', () => {
      const y = window.scrollY;
      const seen = y + window.innerHeight;
      const page = document.documentElement.scrollHeight;
      if (page > 0 && seen / page >= 0.55) deep = true;
      up = y < lastY ? up + (lastY - y) : 0;
      lastY = y;
      if (deep && up >= 400) open();
    }, { passive: true });
  };
  notchExitIntent();

  // ── arrival from an ad ─────────────────────────────────────────────────
  //
  // The third opening. A tagged link (utm_term is the Meta ad id; utm_medium
  // is paid_social on every ad URL) lands on the product page, and after a
  // short, editor-set delay the panel opens on the offer copy.
  //
  // fbclid alone is NOT a trigger: an organic share carries it too, and an
  // offer thrown at someone who tapped a friend's link is the popup that
  // should not have fired.
  //
  // The ad is never read into the panel. Which ad brought the visitor is
  // already on every event of the session through the UTM parameters the
  // pixel records, and the signup joins to that person by browser id. The
  // question below is a separate fact about the customer, asked the same way
  // whoever they are. The query string is never rewritten: the pixel reads it.
  const notchAnswerValue = (form, radio) => {
    const base = form.querySelector('input[type="hidden"][name="contact[tags]"]');
    let value = base ? base.value : '';
    const id = (document.cookie.match(/(?:^|; )_shopify_y=([^;]+)/) || [])[1];
    if (id && !/(^|,)uid:/.test(value)) value += ',uid:' + id;
    return value + ',' + radio.dataset.notchAnswer;
  };
  const notchAdGate = () => {
    const panel = document.querySelector('.notch-prelaunch');
    if (!panel || panel.dataset.notchAd !== 'on') return;
    if (window.Shopify && window.Shopify.designMode) return;
    const params = new URLSearchParams(location.search);
    const isAd = params.get('utm_medium') === 'paid_social' || !!params.get('utm_term');
    if (!isAd) return;
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') return;
    if (notchGateBlocked(panel)) return;
    const delay = (Number(panel.dataset.notchAdDelay) || 3) * 1000;
    setTimeout(() => notchOpenGate(panel, 'ad'), delay);
  };
  try { notchAdGate(); } catch (e) { /* never take the repairs below down with it */ }

  // ── closing gives the history entry back ──────────────────────────────
  //
  // Opening spends one entry, because :target is the only thing that can
  // open this panel with no script and only a real fragment navigation sets
  // it — replaceState moves the URL but never matches :target, which was
  // checked. So the entry is unavoidable; what matters is giving it back.
  //
  // It used to be kept. The scrim and the X are <a href="#">, which pushes a
  // SECOND entry, so a phone's back gesture walked into the panel it had
  // just dismissed: history.length went 31, 32 on open, 33 on close, and
  // back() reopened it. You could not leave the page.
  //
  // Going back instead of forward makes the two gestures agree: back closes
  // the panel once, and back again leaves the page, which is what a phone
  // user means by it either way.
  const notchGateClose = () => {
    const panel = document.getElementById('notch-prelaunch');
    if (!panel) return;
    panel.querySelectorAll('a[href="#"]').forEach((link) =>
      link.addEventListener('click', (event) => {
        // Never go back from the confirmation. Shopify answers the form
        // at a new url, so the entry behind it is the page as it stood
        // before the post: back() handed someone who had just been told
        // they were on the list the empty form again, question and all.
        // Standing aside leaves the link to close the panel, as it does
        // with no script.
        if (panel.querySelector('[data-notch-captured], .notch-prelaunch__success-heading')) return;

        // Landed straight on the fragment, so there is nothing of ours to
        // pop and back() would leave the site. Let the link do its job.
        if (history.length <= 1) return;
        event.preventDefault();
        history.back();
      })
    );
  };
  notchGateClose();

  // ── back, after you are already on the list ────────────────────────────
  //
  // The close control dodges the stale history entry by standing aside
  // (see notchGateClose). The browser's own back gesture cannot: it is a
  // navigation, not a click, and there is nothing to intercept.
  //
  // The entry cannot be removed, so the panel refuses to open on it. Two
  // conditions, both needed:
  //   · this browser has already given an address (notch_gate_done)
  //   · we arrived by back or forward, not by clicking Checkout — someone
  //     already on the list still has to be told the store has not opened
  //     when they try to buy something.
  const notchGateBackGuard = () => {
    const panel = document.getElementById('notch-prelaunch');
    if (!panel) return;

    const captured = () => {
      try { return localStorage.getItem('notch_gate_done') === '1'; } catch (e) { return false; }
    };
    const cameBack = (persisted) => {
      if (persisted) return true;
      const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      return !!nav && nav.type === 'back_forward';
    };

    window.addEventListener('pageshow', (event) => {
      if (!location.hash || !captured() || !cameBack(event.persisted)) return;
      panel.dataset.notchDismissed = '';
      // Tidy the url, so a later reload does not reopen it.
      history.replaceState(null, '', location.pathname + location.search);
    });
  };
  notchGateBackGuard();

  // ── open at the top ───────────────────────────────────────────────────
  //
  // Navigating to the fragment scrolls the panel into view, and because the
  // panel is itself the scroll container that left it 56px down on a short
  // screen — far enough that the close control sat above the visible area.
  // Opening a dialog with its only visible exit already scrolled off is the
  // whole complaint about this thing, so the container is put back to zero
  // each time it opens.
  const notchGateTop = () => {
    const panel = document.getElementById('notch-prelaunch');
    if (!panel) return;
    const toTop = () => {
      if (location.hash === '#' + panel.id) panel.scrollTop = 0;
    };
    window.addEventListener('hashchange', toTop);
    toTop();
  };
  notchGateTop();

  // ── the browser id rides on the answer too ─────────────────────────────
  //
  // assets/notch-analytics.js stamps `uid:<_shopify_y>` onto the hidden tags
  // input, which is what joins the Shopify customer record to this browser's
  // PostHog person. An answered question posts the radio's value INSTEAD of
  // that input, so without this the id would be lost for exactly the people
  // who answered. The cookie is read again here rather than trusted from the
  // hidden input, because it can be set after the tracker's first pass.
  const notchCarryId = () => {
    const form = document.querySelector('.notch-prelaunch__form');
    if (!form) return;
    form.addEventListener('change', (event) => {
      const radio = event.target;
      if (!radio.matches || !radio.matches('input[name="contact[tags]"][data-notch-answer]')) return;
      radio.value = notchAnswerValue(form, radio);
    });

  };
  notchCarryId();

  } catch(e) { console.error(e); }
})();
})();
